module.exports = __webpack_public_path__ + "assets/img/tabs-course-6a3a4029.png";